import React from "react";
import { eventPhoto } from "../config/images";

/**
 * EventCard
 * Props:
 *  - event: { title, date, location, description, image }
 */
function EventCard({ event }) {
  return (
    <div className="card apk-card overflow-hidden h-100">
      <img src={eventPhoto(event.image)} alt={event.title} className="w-100" style={{ height: "190px", objectFit: "cover" }} />
      <div className="p-4">
        <div className="d-flex align-items-center gap-2 small text-orange fw-semibold mb-2">
          <i className="bi bi-calendar-event-fill"></i>
          <span>{event.date}</span>
        </div>
        <h5 className="fw-bold text-navy mb-1">{event.title}</h5>
        <p className="small text-secondary mb-2">
          <i className="bi bi-geo-alt-fill me-1"></i>
          {event.location}
        </p>
        <p className="text-secondary small mb-0">{event.description}</p>
      </div>
    </div>
  );
}

export default EventCard;
